import React, { FC } from 'react';
import FormBlock from 'src/components/FormBlock';
import TableSimple from 'src/components/TableSimple';
import translate from '@translate';
import { TableColumnType } from 'src/types/table';
import { TransportEventType } from 'src/types/transportDetail';
import { Typography } from '@mui/material';

const allColumns: TableColumnType[] = [
    { key: 'OCCURRED_AT', label: 'occurredAt', type: 'dateTime', defaultShow: true },
    { key: 'STATUS', label: 'status', defaultShow: true },
    { key: 'SHIPPER_STATUS_CODE', label: 'shipperStatusCode', defaultShow: true },
    { key: 'SHIPPER_STATUS_TEXT', label: 'shipperStatusText', defaultShow: true },
    { key: 'SOURCE', label: 'source', defaultShow: true },
    { key: 'LOCATION', label: 'location', defaultShow: true },
    { key: 'ID_TRANSPORT_PACKAGE', label: 'packageId', defaultShow: true },
];

export interface EventsBlockPropsType {
    data: TransportEventType[] | null;
}

const EventsBlock: FC<EventsBlockPropsType> = (props) => {
    if (!props.data?.length) {
        return (
            <FormBlock>
                <Typography>{translate('transportDetail.events.empty')}</Typography>
            </FormBlock>
        );
    }

    return (
        <FormBlock>
            <TableSimple
                rowIdKey="ID"
                rows={props.data}
                allColumns={allColumns}
                columsLabelPrefix="transportDetail.events.table"
                initSort={{ column: 'OCCURRED_AT', direction: 'DESC' }}
                disableFilter
            />
        </FormBlock>
    );
};

export default EventsBlock;
